import styled from 'styled-components';

export const Title = styled.h1`
  font-weight: 700;
  margin-bottom: 24px;
`;
